module.exports = __webpack_public_path__ + "img/icon-dash-configuracoes@2x.346cb422.png";